import { log, warn, isObject, isArray } from './utils'
import BuryTool from './bury-tool'

import {
  ClassBuryPoint,
  BuryPointOptions,
  BuryPointModules,
  MultBuryItem,
  BuryToolMap
} from './types/bury-point'
import {
  BuryParams,
} from './types/bury-tool'

const hasOwn = (o: object, k: string) => Object.prototype.hasOwnProperty.call(o, k)

const getToolMap = (modules: BuryPointModules): BuryToolMap => {
  const modulesRequireKeyList = ['positions']
  const err: string[] = []
  const map: BuryToolMap = {}
  for (const namespace in modules) {
    if (hasOwn(modules, namespace)) {
      const item = modules[namespace]
      if (isObject(item)) {
        const namedKeys = Object.keys(item)
        const _err: string[] = []
        modulesRequireKeyList.forEach((key) => {
          if (!namedKeys.includes(key)) {
            _err.push(`module ${namespace} 缺失 ${key}`)
          }
        })
        if (_err.length > 0) {
          err.push(..._err)
        } else {
          map[namespace] = new BuryTool(namespace, item)
        }
      } else {
        err.push(`module ${namespace} 应为"object"类型`)
      }
    }
  }
  if (err.length > 0) {
    warn(err.join('\n'))
  }
  return map
}

export default class BuryPoint implements ClassBuryPoint {
  buryToolMap: BuryToolMap = {};

  constructor({
    modules
  }: BuryPointOptions) {
    if (!modules || !isObject(modules)) {
      warn('modules 为必传参数且为"object"类型')
      return
    }

    this.buryToolMap = getToolMap(modules)
  }

  /**
   * 单个上报
   * @param point 命名空间/埋点位置
   * @param params 额外参数
   */
  report(...arg: [
    string,
    (BuryParams | string | MultBuryItem[])?,
    BuryParams?
  ]) {
    const [flag, p1, p2] = arg
    const isOne = flag.indexOf('/') !== -1
    if (isOne) {
      this.one(flag, <BuryParams>p1)
    } else {
      this.mult(flag, <any>p1, p2)
    }
  }

  one(point: string, params?: BuryParams) {
    try {
      const split = point.split('/')
      const namespace = split[0]
      const tool = this.buryToolMap[namespace]
      const positionKey = split[1]
      if (!tool) {
        log(`report: 无法找到 ${point} 对应的埋点工具 namespace=${namespace}`)
        return
      }
      if (!positionKey) {
        log(`report: 无法找到 ${point} 对应的埋点key positionKey=${positionKey}`)
        return
      }
      tool.send(positionKey, params)
    } catch (error) {
      log(error)
    }
  }

  mult(namespace: string, points: any, commonParams?: BuryParams): void {
    try {
      const tool = this.buryToolMap[namespace]
      if (!tool) {
        log(`reportMult: 无法找到 ${namespace} 对应的埋点工具`)
        return
      }
      let pointsArray = []
      if (typeof points === 'string') {
        pointsArray = points.split(',').map((el) => {
          return [el, { ...commonParams }]
        })
      } else if (isArray(points)) {
        pointsArray = points.map((el: MultBuryItem) => {
          if (el.key) {
            return [el.key, { ...commonParams, ...(el.params || {}) }]
          }
          return null
        }).filter((el: MultBuryItem) => { return !!el })
      } else {
        log(`reportMult: points=${points} 不符合要求 in namespace ${namespace}`)
      }

      pointsArray.forEach((pos: [string, BuryParams?]) => {
        tool.send(...pos)
      })
    } catch (error) {
      log(error)
    }
  }
}
